module.exports = [{
      plugin: require('/codebuild/output/src442232351/src/jia-public-site/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/codebuild/output/src442232351/src/jia-public-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
